import { createSlice } from "@reduxjs/toolkit";

export interface HomeState {
  data: [] | null | any;
  totalPages: number | null;
  currentPage: number | null;
  totalRecords: number | null;

  dataCity: [] | null | any;
  totalPagesCity: number | null;
  currentPageCity: number | null;
  totalRecordsCity: number | null;
}

const initialState: HomeState = {
  data: null,
  totalPages: null,
  currentPage: null,
  totalRecords: null,

  dataCity: null,
  totalPagesCity: null,
  currentPageCity: null,
  totalRecordsCity: null,
};

export const homeSlice = createSlice({
  name: "home",
  initialState,
  reducers: {
    setHomeDetail: (state: any, action) => {
      state.data = action.payload.data;
      state.totalPages = action.payload.totalPages;
      state.currentPage = action.payload.currentPage;
      state.totalRecords = action.payload.totalRecords;
    },
    addHomeDetail: (state: any, action) => {
      state.data = [action.payload];
    },
    homeReset: (state) => {
      state = initialState;
    },
    setHomeCityDetail: (state: any, action) => {
      state.dataCity = action.payload.data;
      state.totalPagesCity = action.payload.totalPages;
      state.currentPageCity = action.payload.currentPage;
      state.totalRecordsCity = action.payload.totalRecords;
    },
  },
});

export const { setHomeDetail, addHomeDetail, homeReset, setHomeCityDetail } =
  homeSlice.actions;
export const getUserData = (state: any) => state.home.data;
export const getUserCityData = (state: any) => state.home.dataCity;
export const getCityDataRecod = (state: any) => state.home.totalRecordsCity;
export const getUserId = (state: any) => state.home.data?.id;
export const getTotalPage = (state: any) => state.home.totalPages;
export const getCurrentPage = (state: any) => state.home.currentPage;
export const getTotalRecords = (state: any) => state.home.totalRecords;

export default homeSlice.reducer;
